import moveRoutes from './routes'

/* @ngInject */
const moveRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(moveRoutes.index.path, {
      url: moveRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'moveCtrl',
    })
    .state(moveRoutes.selectWagons.path, {
      url: moveRoutes.selectWagons.url,
      template: require('./templates/selectWagons.html'),
    })
    .state(moveRoutes.selectRailway.path, {
      url: moveRoutes.selectRailway.url,
      template: require('./templates/selectRailway.html'),
    })
    .state(moveRoutes.report.path, {
      url: moveRoutes.report.url,
      template: require('./templates/report.html'),
    })
}

export default moveRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/move/move.routes.js